module.exports = __webpack_public_path__ + "static/media/calendar-input-preview.2767eeee.png";